import { removeEmptyKeys } from ".";
import axiosApi, { refreshTokenRequest } from "./axios";

export const loginApi = (payload) =>
  axiosApi.post("auth/login/as_admin", payload);

export const verifyOtpApi = (payload) =>
  axiosApi.post("auth/verify_otp", payload);

export const verify2faOtpApi = (payload) =>
  axiosApi.post("auth/login/2fa/verify", payload);

export const setup2FaApi = () => axiosApi.post("auth/2fa/setup");

export const verify2FaApi = (otp) =>
  axiosApi.post("auth/2fa/verify", { otp });

export const generateRecoveryCodeApi = () =>
  axiosApi.get("auth/2fa/generate_recovery_codes");

export const disableTwoFaApi = (data) =>
  axiosApi.post("auth/2fa/disable", data);

export const resendEmailOtpApi = (email) =>
  axiosApi.post("auth/resend_otp", { email });

export const verifyRecoveryCodeApi = (data) =>
  axiosApi.post("auth/2fa/verify_recovery_code", data);

export const getAuthAccountApi = () => axiosApi.get("auth/account");

export const getTransactionList = (
  txnType = "",
  assetType = "",
  status = "",
  email = "",
  page = 0,
  pageSize = 10,
  search = "",
  mainAccountEmail = "",
  clientType = "otc",
) => {
  const params = new URLSearchParams({
    txn_type: txnType,
    "asset__asset_type": assetType,
    status: status || "",
    "account__user__email": email || "",
    page: String(page),
    page_size: String(pageSize),
    search: search || "",
  });
  if (mainAccountEmail) params.set("main_account_email", mainAccountEmail);
  if (clientType) params.set("client_type", clientType);
  return axiosApi.get(`dashboard/otc/transaction/?${params.toString()}`);
};

export const getTransactionListCommon = (
  txnType = "",
  assetType = "",
  status = "",
  accId = "",
  page = 0,
  pageSize = 10,
) =>
  axiosApi.get(
    `dashboard/transactions/?txn_type=${txnType}&asset__symbol=${assetType}&status=${status}&account=${accId}&page=${page}&page_size=${pageSize}`,
  );

export const editTransactionApi = (id, payload) => {
  return axiosApi.patch(`dashboard/otc/transaction/update/${id}/`, payload);
};

export const requestEditTransactionApi = (payload) =>
  axiosApi.post(`dashboard/otc/create_txn_change_request/`, payload);

export const editTransactionCommonApi = (id, payload) =>
  axiosApi.patch(`dashboard/transactions/${id}/`, payload);

export const createOrderApi = (payload) =>
  axiosApi.post("dashboard/otc/order/create/", payload);

export const transactionCreateCrypto = (payload) =>
  axiosApi.post("dashboard/otc/transaction/create/", payload);

export const transactionCreateCommon = (payload) =>
  axiosApi.post("dashboard/transactions/", payload);

export const searchEmailOtcApi = (query, isMainOnly = false, clientType = "") => {
  const params = new URLSearchParams({ query });
  if (isMainOnly) params.set("is_main", "true");
  if (clientType) params.set("client_type", clientType);
  return axiosApi.get(`dashboard/otc/account/search/?${params.toString()}`);
};

export const getOtcAccountKycDetailsApi = (accountId, clientType = "") => {
  const params = new URLSearchParams({ account_id: accountId });
  if (clientType) {
    params.set("client_type", clientType);
  }
  return axiosApi.get(`dashboard/otc/account_kyc_details/?${params.toString()}`);
};

export const searchEmailForAllApi = (
  query,
  isMainOnly = false,
  clientType = "",
  searchType = "",
  userType = "",
) => {
  const params = new URLSearchParams({ query });
  if (isMainOnly) {
    params.append("is_main", "true");
  }
  if (clientType) params.set("client_type", clientType);
  if (searchType) params.set("search_type", searchType);
  if (userType) params.set("user_type", userType);
  return axiosApi.get(`dashboard/account/search/?${params.toString()}`);
};

export const otcOrderListApi = (
  page = 0,
  pageSize = 10,
  email = "",
  mainAccountEmail = "",
  clientType = "otc",
) => {
  const params = new URLSearchParams({
    page: String(page),
    page_size: String(pageSize),
  });
  if (email) params.set("account__user__email", email);
  if (mainAccountEmail) params.set("main_account_email", mainAccountEmail);
  if (clientType) params.set("client_type", clientType);
  return axiosApi.get(`dashboard/otc/order/?${params.toString()}`);
};

export const twoWaySwapApi = (payload) =>
  axiosApi.post("dashboard/otc/order/swap/", payload);

export const checkBalanceApi = (payload) =>
  axiosApi.post("dashboard/otc/order/check_balance/", payload);

export const createFiuEntryApi = (payload) =>
  axiosApi.post("dashboard/fiu/create/", removeEmptyKeys(payload));

export const fiuListApi = (query) =>
  axiosApi.get(`dashboard/fiu/list/?${query}`);

export const searchAccApi = (id) =>
  axiosApi.get(`dashboard/fiu/account/${id}/`);

export const downloadUserReportApi = (id) =>
  axiosApi.get(`dashboard/fiu/account/download/${id}/`);

export const findFiuApi = (id) =>
  axiosApi.get(`dashboard/fiu/search/?id=${id}`);

export const updateFiuEntryApi = (id, payload) =>
  axiosApi.patch(`dashboard/fiu/update/${id}/`, payload);

export const addKycAdditionalApi = (data) =>
  axiosApi.patch(`kyc/onboarding/additional_kyc_data/`, data);

export const affiliatedEntyApi = (data) =>
  axiosApi.post(`kyc/onboarding/affiliated_entity_details/`, data);

export const affiliatedPanUpdate = (affiliatedId, data) =>
  axiosApi.patch(`kyc/onboarding/affiliated_pan/${affiliatedId}/`, data);

export const panUpdateApi = (userId, data) =>
  axiosApi.patch(`kyc/onboarding/pan/${userId}/`, data);

export const rotateUserAccountApiKeyApi = () =>
  axiosApi.get(`taas/d/main_account_api_key/`);

export const affiliatedAadhaarUpdate = (affiliatedId, data) =>
  axiosApi.patch(`kyc/onboarding/affiliated_aadhaar/${affiliatedId}/`, data);

export const addBankApi = (data) => axiosApi.post("kyc/onboarding/bank/", data);

export const additionalKycDataApi = (accId) =>
  axiosApi.get(`kyc/onboarding/additional_kyc_data/?account_id=${accId}`);

export const documentFileListApi = (
  accId = "",
  docType = "",
  ownertype = "",
  affiliated_entity_id = "",
) =>
  axiosApi.get(
    `kyc/onboarding/document_file/?account_id=${accId}&doc_type=${docType}&owner_type=${ownertype}&affiliated_entity_id=${affiliated_entity_id}`,
  );

export const createAccApi = (data) => axiosApi.post("dashboard/account/", data);

export const getAccDetailsOnboarding = (email) =>
  axiosApi.get("dashboard/account/?email=" + email);

export const updateAccDetails = (email, data) =>
  axiosApi.patch("dashboard/account/?email=" + email, data);

export const getBanks = (accId) =>
  axiosApi.get(`/kyc/onboarding/bank/?account_id=${accId}`);

export const affiliatedEntiyListApi = (accId, type) =>
  axiosApi.get(
    `kyc/onboarding/affiliated_entity_details/?account_id=${accId}&type=${type}`,
  );

export const updateAffiliatedEntity = (id, data) =>
  axiosApi.patch(`kyc/onboarding/affiliated_entity_details/${id}/`, data);

export const getAffiliatedPan = (affiliatedId) =>
  axiosApi.get(`kyc/onboarding/affiliated_pan/${affiliatedId}/`);

export const addWalletAddressApi = (data) =>
  axiosApi.post(`kyc/onboarding/whitelisted_crypto_address/`, data);

export const updateWalletAddressApi = (id, data) =>
  axiosApi.patch(`kyc/onboarding/whitelisted_crypto_address/${id}/`, data);

export const getWalletList = (id) =>
  axiosApi.get(`kyc/onboarding/whitelisted_crypto_address/?account_id=${id}`);

export const dcxTradeDataApi = (date) =>
  axiosApi.get(`dashboard/dcx/trade_data/?date=${date}`);

export const accBalanceListApi = (
  clientType = "otc",
  email = "",
  page = 0,
  pageSize = 10,
  mainAccountEmail = "",
) =>
  axiosApi.get(
    `dashboard/account/balance/?client_type=${clientType}&email=${email || ""}&page=${page}&page_size=${pageSize}&main_account_email=${mainAccountEmail || ""}`,
  );

export const downloadTxnOrderHistoryApi = (
  id,
  clientType,
  startDate,
  endDate,
  role,
) =>
  axiosApi.get(
    `/dashboard/accounting/txn_and_order_history/download/?account_id_list=${id}&start_date=${startDate}&end_date=${endDate}&client_type=${clientType}&role=${role}`,
  );
export const getDcxCarretBalance = () => axiosApi.get("dashboard/dcx/balance/");

export const getRevenueData = (startDate, endDate, txn, order, role) =>
  axiosApi.get(
    `/dashboard/accounting/revenue_data/?start_date=${startDate}&end_date=${endDate}&transaction=${txn}&order=${order}&role=${role}`,
  );

export const downloadAccountBalanceApi = (id, clientType, date, role) =>
  axiosApi.get(
    `/dashboard/accounting/account_balances/?account_id_list=${id}&date=${date}&client_type=${clientType}&role=${role}`,
  );

export const downloadOrderDataApi = (
  id,
  clientType,
  startDate,
  endDate,
  role,
) =>
  axiosApi.get(
    `/dashboard/accounting/order_data/download/?account_id_list=${id}&start_date=${startDate}&end_date=${endDate}&client_type=${clientType}&role=${role}`,
  );

export const getOrderDetails = (id) =>
  axiosApi.get(`dashboard/accounting/order_data/?account_id_list=${id}`);

export const downloadLedgerApi = (id, clientType, startDate, endDate, role) =>
  axiosApi.get(
    `dashboard/accounting/ledger/download/?account_id_list=${id}&client_type=${clientType}&start_date=${startDate}&end_date=${endDate}&role=${role}`,
  );

export const getRfiAlertList = (status = "", page = 0, pageSize = 10) =>
  axiosApi.get(
    `dashboard/rfi/rfi_alert/?action=${status}&page=${page}&page_size=${pageSize}`,
  );

export const editRfiAlertApi = (id, payload) =>
  axiosApi.patch(`dashboard/rfi/rfi_alert/update/${id}/`, payload);

export const getDashboardAlertList = (
  page = 0,
  pageSize = 10,
  isRead = false,
) =>
  axiosApi.get(
    `notifications/alerts/?page=${page}&page_size=${pageSize}&is_read=${isRead}`,
  );

export const editDashboardAlertApi = (id, payload) =>
  axiosApi.patch(`notifications/alerts/${id}/`, payload);

export const checkPanApi = (payload) =>
  axiosApi.post(`dashboard/kyc/check_pan/`, payload);

export const checkAadhaarApi = (payload) =>
  axiosApi.post(`dashboard/kyc/check_aadhaar/`, payload);

export const checkReqIdIdfyApi = (payload) =>
  axiosApi.post(`dashboard/kyc/verify_idfy_task_id/`, payload);

export const checkBankApi = (payload) =>
  axiosApi.post(`dashboard/kyc/check_bank_details/`, payload);

export const getAssetPriceApi = (symbol, side) =>
  axiosApi.get(`exchange/price?ticker=${symbol}&side=${side}`);

export const placeDcxOrderForCarretApi = (payload) =>
  axiosApi.post(`dashboard/dcx/place_order_on_dcx/`, payload);

export const placeDcxOrderForUserApi = (payload) =>
  axiosApi.post(`dashboard/dcx/place_order_for_user/`, payload);

export const searchAssetApi = (symbol) =>
  axiosApi.get(`exchange/market?search=${symbol}`);

export const aggregateReportApi = (email = "", symbol = "") =>
  axiosApi.get(
    `dashboard/accounting/aggregate_data/?email=${email}&asset__symbol=${symbol}`,
  );

export const aggregateReportPvC = (
  email = "",
  symbol = "",
  page = 1,
  pageSize = 10,
) =>
  axiosApi.get(
    `dashboard/accounting/aggregate_data/private_client/?email=${email}&page=${page}&page_size=${pageSize}`,
  );

export const pvCAssetListingApi = (email = "") =>
  axiosApi.get(`dashboard/accounting/private_client_list/?email=${email}`);

export const pvCAssetListingByAssetApi = (email = "", asset = "") =>
  axiosApi.get(
    `dashboard/accounting/private_client_logs/?email=${email}&transaction__asset__symbol=${asset}`,
  );

export const tradingWalletListingApi = (
  email = "",
  asset = "",
  userType = "",
  page = 1,
  pageSize = 10,
  clientType = "",
) =>
  axiosApi.get(
    `dashboard/accounting/trading_wallet_list/?email=${email}&asset__symbol=${asset}&page=${page}&page_size=${pageSize}&account__user_type=${userType}&client_type=${clientType}`,
  );

export const getWhiteListedCryptoAddressApi = (
  asset = "",
  network = "",
  status = "",
  email = "",
) =>
  axiosApi.get(
    `/dashboard/otc/whitelisted_crypto_address/?asset__symbol=${asset}&network=${network}&status=${status}&email=${email}`,
  );

export const downloadKycDataApi = (email, userType, clientType, role) =>
  axiosApi.get(
    `dashboard/accounting/kyc_data_internal/download/?email=${email}&user_type=${userType}&client_type=${clientType}&role=${role}`,
  );

export const downloadTxnHistoryApi = (startDate, endDate) =>
  axiosApi.get(
    `dashboard/accounting/txn_history/download/?start_date=${startDate}&end_date=${endDate}`,
  );

export const downloadOrderHistoryApi = (startDate, endDate) =>
  axiosApi.get(
    `dashboard/accounting/order_history/download/?start_date=${startDate}&end_date=${endDate}`,
  );

export const downloadTdsReportApi = (startDate, endDate) =>
  axiosApi.get(
    `dashboard/accounting/tds_report/download/?start_date=${startDate}&end_date=${endDate}`,
  );

export const kycDataListApi = (email) =>
  axiosApi.get(`dashboard/accounting/kyc_data/list/?email=${email}`);

export const generateExternalLinkApi = (data) =>
  axiosApi.post(`kyc/onboarding/generate_external_kyc_link/`, data);

export const uploadFileApi = (payload) =>
  axiosApi.post(`master/generate_presigned_url`, payload);

export const getTaasTnxListApi = ({
  parentEmail = "",
  page = 1,
  pageSize = 10,
  status = "pending",
  assetType = "fiat",
  asset = "",
  txnType = "deposit",
}) =>
  axiosApi.get(
    `dashboard/penguin/transaction/?parent_email=${
      parentEmail || ""
    }&page=${page}&page_size=${pageSize}&status=${status}&asset_type=${assetType}&asset=${asset}&txn_type=${txnType}`,
  );

export const getTaasKYCListApi = ({
  parentEmail,
  page = 1,
  pageSize = 10,
  status = "pending",
}) =>
  axiosApi.get(
    `dashboard/penguin/kyc/?parent_email=${parentEmail}&page=${page}&page_size=${pageSize}&status=${status}`,
  );

export const downloadTaasTnxDataApi = ({
  parentEmail,
  status,
  assetType = "fiat",
}) =>
  axiosApi.get(
    `dashboard/penguin/transaction/download/?parent_email=${parentEmail}&status=${status}&asset_type=${assetType}`,
  );

export const editTaasKYCListApi = (payload) =>
  axiosApi.patch(`dashboard/penguin/kyc/`, payload);

// taas fees management APIs
export const getFeeModuleListApi = (params = {}) => {
  const queryParams = removeEmptyKeys(params);
  const queryString = new URLSearchParams(queryParams).toString();
  return axiosApi.get(`dashboard/taas-fees/modules/?${queryString}`);
};

export const getSingleFeeModuleApi = (id) =>
  axiosApi.get(`dashboard/taas-fees/modules/${id}/`);

export const ActivateDeactivateFeeModuleApi = (id, mode) =>
  axiosApi.post(`dashboard/taas-fees/modules/${id}/${mode}/`);

export const DeleteFeeModuleApi = (id) =>
  axiosApi.delete(`dashboard/taas-fees/modules/${id}/`);

export const getMainAccountListApi = (search = "") =>
  axiosApi.get(`dashboard/taas-fees/main-accounts/?search=${search}`);

export const getRouteListApi = (search = "") =>
  axiosApi.get(`dashboard/taas-fees/routes/`)

export const createFeeModuleApi = (payload) =>
  axiosApi.post(`dashboard/taas-fees/modules/`, payload);

export const updateFeeModuleApi = (id, payload) =>
  axiosApi.patch(`dashboard/taas-fees/modules/${id}/`, payload);

export const createExchangeRateApi = (payload) =>
  axiosApi.post(`dashboard/taas-fees/exchange-rate-preview/`, payload);

export const previewFeeModuleApi = (id, payload) =>
  axiosApi.post(`dashboard/taas-fees/modules/${id}/preview/`,payload);

export const createFeeModulePreviewApi = (id, payload) =>
  axiosApi.post(`dashboard/taas-fees/modules/${id}/preview/`, payload);
//need to be removed
export const getFeeTemplatesApi = (params = {}) => {
  const queryParams = removeEmptyKeys(params);
  const queryString = new URLSearchParams(queryParams).toString();
  return axiosApi.get(`taas/d/fee_templates/?${queryString}`);
};

export const createFeeTemplateApi = (payload) =>
  axiosApi.post(`taas/d/fee_templates/`, payload);

export const updateFeeTemplateApi = (id, payload) =>
  axiosApi.put(`taas/d/fee_templates/${id}/`, payload);

export const deleteFeeTemplateApi = (id) =>
  axiosApi.delete(`taas/d/fee_templates/${id}/`);

export const cloneFeeTemplateApi = (id, payload) =>
  axiosApi.post(`taas/d/fee_templates/${id}/clone/`, payload);

export const getFeeSubscriptionsApi = (params = {}) => {
  const queryParams = removeEmptyKeys(params);
  const queryString = new URLSearchParams(queryParams).toString();
  return axiosApi.get(`taas/d/fee_subscriptions/?${queryString}`);
};

export const createFeeSubscriptionApi = (payload) =>
  axiosApi.post(`taas/d/fee_subscriptions/`, payload);

export const updateFeeSubscriptionApi = (id, payload) =>
  axiosApi.put(`taas/d/fee_subscriptions/${id}/`, payload);

export const deleteFeeSubscriptionApi = (id) =>
  axiosApi.delete(`taas/d/fee_subscriptions/${id}/`);

export const getFeeOverridesApi = (params = {}) => {
  const queryParams = removeEmptyKeys(params);
  const queryString = new URLSearchParams(queryParams).toString();
  return axiosApi.get(`taas/d/fee_overrides/?${queryString}`);
};

export const createFeeOverrideApi = (payload) =>
  axiosApi.post(`taas/d/fee_overrides/`, payload);

export const updateFeeOverrideApi = (id, payload) =>
  axiosApi.put(`taas/d/fee_overrides/${id}/`, payload);

export const deleteFeeOverrideApi = (id) =>
  axiosApi.delete(`taas/d/fee_overrides/${id}/`);

export const bulkAssignFeesApi = (payload) =>
  axiosApi.post(`taas/d/bulk_assign_fees/`, payload);

export const bulkCreateOverridesApi = (payload) =>
  axiosApi.post(`taas/d/bulk_fee_overrides/`, payload);

export const getFeeAnalyticsApi = (params = {}) => {
  const queryParams = removeEmptyKeys(params);
  const queryString = new URLSearchParams(queryParams).toString();
  return axiosApi.get(`taas/d/fee_analytics/?${queryString}`);
};

export const getFeeDashboardSummaryApi = () =>
  axiosApi.get(`taas/d/fee_dashboard_summary/`);

export const searchAccountsForFeesApi = (query = "") =>
  axiosApi.get(`taas/d/accounts_search/?query=${query}`);

export const calculateFeesApi = (payload) =>
  axiosApi.post(`taas/d/calculate_fees/`, payload);

export const validateFeesApi = (payload) =>
  axiosApi.post(`taas/d/fee_validation/`, payload);

// Test Quotes APIs
export const getMainAccountsApi = (params = {}) => {
  const queryParams = removeEmptyKeys(params);
  const queryString = new URLSearchParams(queryParams).toString();
  return axiosApi.get(`taas/d/accounts/?is_main=true&${queryString}`);
};

export const testQuoteApi = (payload) =>
  axiosApi.post(`taas/d/test_quote/`, payload);

//transaction dashboard api's
export const getTransactionListApi = (
  txnType = "",
  assetType = "",
  status = "",
  fromDate = "",
  toDate = "",
  email = "",
  page = 0,
  pageSize = 10,
  deposited_date_exists = false,
  accountType = "",
  mainAccountEmail = "",
) =>
  axiosApi.get(
    `dashboard/crypto-currency/transaction/?txn_type=${txnType}&asset__asset_type=${assetType}&status=${status}&search=${email}&page=${page}&main_account_email=${mainAccountEmail}&page_size=${pageSize}&deposited_date_exists=${deposited_date_exists}&from_date=${fromDate}&to_date=${toDate}${
      accountType ? `&client_type=${accountType}` : ""
    }`,
  );

export const editTransactionListApi = (id, payload) =>
  axiosApi.patch(
    `dashboard/crypto-currency/transaction/update/${id}/`,
    payload,
  );

export const getCarretBankListApi = () => axiosApi.get(`master/carret_banks`);

export const getSwapOrderHistoryListApi = ({
  search = "",
  mainAccountEmail = "",
  status = "",
  side = "",
  clientType = "retail,taas_r,taas_r_user",
  page = 0,
  pageSize = 10,
} = {}) => {
  const params = new URLSearchParams({
    search: search || "",
    main_account_email: mainAccountEmail || "",
    status: status || "",
    side: side || "",
    client_type: clientType || "retail,taas_r,taas_r_user",
    page: String(page),
    page_size: String(pageSize),
  });
  return axiosApi.get(`dashboard/crypto-currency/order/?${params.toString()}`);
};

export const getOtcTransactionChangeRequestListApi = (
  txnType = "",
  assetType = "",
  status = "",
  email = "",
  page = 0,
  pageSize = 10,
  searchId = "",
  mainAccountEmail = "",
  clientType = "otc",
) => {
  const params = new URLSearchParams({
    status,
    account__user__email: email,
    requested_by__user__email: email,
    "transaction__asset__asset_type": assetType,
    "transaction__txn_type": txnType,
    page: String(page),
    page_size: String(pageSize),
  });
  // UTR lives on the related transaction; `search` does not filter it
  if (searchId) {
    params.set("transaction__utr_no", searchId);
  }
  if (mainAccountEmail) params.set("main_account_email", mainAccountEmail);
  if (clientType) params.set("client_type", clientType);
  return axiosApi.get(`dashboard/otc/list_txn_change_requests/?${params.toString()}`);
};

export const approveRejectChangeRequestApi = (id, payload) =>
  axiosApi.patch(`dashboard/otc/review_txn_change_request/${id}/`, payload);

export const getUserDocListApi = (id, kycCycleId = null) => {
  let url = `dashboard/onboarding/documents/?account_id=${id}`;
  if (kycCycleId) {
    url += `&kyc_cycle_id=${kycCycleId}`;
  }
  return axiosApi.get(url);
};

export const getUserKybAffiliantedApi = (id, type, kycCycleId = null) => {
  let url = `kyc/onboarding/affiliated_entity_details/?account_id=${id}&type=${type}`;
  if (kycCycleId) {
    url += `&kyc_cycle_id=${kycCycleId}`;
  }
  return axiosApi.get(url);
};

export const getKybWalletWishListApi = (id) =>
  axiosApi.get(`dashboard/onboarding/crypto-addresses/?account_id=${id}`);

export const updateKybUploadedDocStatusApi = (payload) =>
  axiosApi.patch(`dashboard/onboarding/documents/`, payload);

export const uploadFileToS3Api = (data) =>
  axiosApi.post("master/upload_file", data);

export const uploadDocApi = (data) =>
  axiosApi.post("kyc/onboarding/document_file/", data);

export const createKybUploadedDocApi = (payload) =>
  axiosApi.post(`dashboard/onboarding/documents/`, payload);

export const updateKybAffiliatedEntityDataApi = (id, data) =>
  axiosApi.patch(
    `dashboard/onboarding/affiliated-entities/?account_id=${id}/`,
    data,
  );

export const getKybFinalPdfDocApi = (payload) =>
  axiosApi.post(`/kyc/consolidated_kyc_document/`, payload);

// EDD Request List APIs
export const getEddRequestListApi = async (
  status = "",
  fromDate = "",
  toDate = "",
  accountId = "",
  page = 0,
  pageSize = 10,
  search = "",
) => {
  let url = `/dashboard/limits-edd/edd_requests/?status=${status}&page=${page}&page_size=${pageSize}`;

  if (status) url += `&status=${status}`;
  if (fromDate) url += `&from_date=${fromDate}`;
  if (toDate) url += `&to_date=${toDate}`;
  if (accountId) url += `&account_id=${accountId}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;

  return await axiosApi.get(url);
};

export const updateEddLimitApi = async (id, payload) => {
  return await axiosApi.patch(`/edd/requests/${id}/`, payload);
};

export const getEddRequestDocApi = async (id = "") => {
  return await axiosApi.get(`dashboard/limits-edd/edd_requests/?id=${id}`);
};

//approve or reject uploaded doc in edd dashboard
export const getEddVerifyApi = async (docId, payload) => {
  return await axiosApi.post(
    `dashboard/limits-edd/edd_documents/${docId}/review/`,
    payload,
  );
};

export const approveRejectEddRequestApi = async (id, payload) => {
  return await axiosApi.post(
    `dashboard/limits-edd/edd_requests/${id}/review/`,
    payload,
  );
};

export const getAccDetailsApi = (accountId) => {
  return axiosApi.get(
    `dashboard/onboarding/account_details/?account_id=${accountId}`,
  );
};

export const downlaodTdsReportApi = (accDetails, startDate, endDate, role) =>
  axiosApi.get(
    `dashboard/accounting/tds_report_internal/download/?account_id_list=${accDetails}&start_date=${startDate}&end_date=${endDate}&role=${role}`,
  );

export const getIpLogsListApi = ({
  fromDate,
  toDate,
  email,
  page = 0,
  pageSize = 10,
}) => {
  return axiosApi.get(
    `/dashboard/api-logs/?from_date=${fromDate}&to_date=${toDate}&email=${email}&page=${page}&page_size=${pageSize}`,
  );
};

export const dowloadIpLogsListDataApi = ({ fromDate, toDate, email }) => {
  return axiosApi.get(
    `/dashboard/api-logs/export/?from_date=${fromDate}&to_date=${toDate}&email=${email}`,
  );
};
export const createBuySellTradeRequestApi = (payload) =>
  axiosApi.post(`dashboard/otc/trade_confirmation_request/create/`, payload);

export const getBuySellTradeRequestListApi = ({
  email = "",
  side = "",
  status = "",
  page = 0,
  pageSize = 10,
  mainAccountEmail = "",
  clientType = "otc",
}) => {
  const params = new URLSearchParams({
    "account__user__email": email || "",
    side: side || "",
    status: status || "",
    page: String(page),
    page_size: String(pageSize),
  });
  if (mainAccountEmail) params.set("main_account_email", mainAccountEmail);
  if (clientType) params.set("client_type", clientType);
  return axiosApi.get(
    `dashboard/otc/order/otc-history/?${params.toString()}`,
  );
};

export const getBuySellTradeConfirmationRequestListApi = ({
  email = "",
  side = "",
  adminstatus = "",
  userStatus = "",
  page = 0,
  pageSize = 10,
}) =>
  axiosApi.get(
    `dashboard/otc/trade_confirmation_request/?page=${page}&page_size=${pageSize}&email=${email}&admin_status=${adminstatus}&user_status=${userStatus}`,
  );

export const reviewBuySellTradeRequestApi = (id, payload) =>
  axiosApi.patch(
    `dashboard/otc/trade_confirmation_request/review/${id}/`,
    payload,
  );

export const exportFiuMatchedDataApi = (accountIds, isI4C) => {
  return axiosApi.get(
    `dashboard/fiu/account/download/matched-users/?account_ids=${accountIds}&is_i4c=${isI4C}`,
  );
};

export const getUserWalletBalanceApi = (mail) =>
  axiosApi.get(`dashboard/account/balance/?email=${mail}`);

export const getUserVerificationStatusApi = (id, kycCycleId = null) => {
  let url = `dashboard/onboarding/verification_task_errors/?account_id=${id}`;
  if (kycCycleId) {
    url += `&kyc_cycle_id=${kycCycleId}`;
  }
  return axiosApi.get(url);
};

export const retriggerVerificationApi = (payload) =>
  axiosApi.post(
    `dashboard/onboarding/verification_task_errors/retry/`,
    payload,
  );

export const getUserApiKeyApi = () =>
  axiosApi.get(`taas/d/main_account_api_key/`);

export const getCinGSTINDetailsApi = (id) =>
  axiosApi.get(`dashboard/onboarding/additional-kyc/?account_id=${id}`);

export const updateCinGSTINDetailsApi = (id, payload) =>
  axiosApi.patch(
    `dashboard/onboarding/additional-kyc/?account_id=${id}`,
    payload,
  );

export const updateAffiliatedEntityApi = (accId, id, payload) =>
  axiosApi.patch(
    `dashboard/onboarding/affiliated-entities/?account_id=${accId}&&id=${id}`,
    payload,
  );

export const updateAccDetailsApi = (accountId, payload) => {
  return axiosApi.patch(
    `dashboard/onboarding/account_details/?account_id=${accountId}`,
    payload,
  );
};

export const updateKybOnbWalletAddressApi = (payload) =>
  axiosApi.patch(
    `dashboard/onboarding/crypto-addresses/`,
    payload,
  );

export const uploadEndDateDataOfFinancialYearApi = (payload) =>
  axiosApi.post(`dashboard/platform-balance/`, payload);

export const getEndDateDataOfFinancialYearApi = (platform, year) =>
  axiosApi.get(
    `dashboard/platform-balance/?platform=${platform}&financial_year=${year}`,
  );

export const getChecklistApi = (id, kycCycleId = null) => {
  let url = `dashboard/onboarding/checklist/?account_id=${id}`;
  if (kycCycleId) {
    url += `&kyc_cycle_id=${kycCycleId}`;
  }
  return axiosApi.get(url);
};

export const updateChecklistApi = (id, payload) =>
  axiosApi.patch(`dashboard/onboarding/checklist/?account_id=${id}`, payload);

export const getDirectorInfoMetadataApi = (id) =>
  axiosApi.get(
    `dashboard/onboarding/meta_data/?account_id=${id}&key=company_info`,
  );

export const getBankDetailsApi = (accId) =>
  axiosApi.get(`dashboard/onboarding/bank/?account_id=${accId}`);

export const deleteBankDetailsApi = (accId, id) =>
  axiosApi.delete(`dashboard/onboarding/bank/?account_id=${accId}&id=${id}`);

export const getCurrentIdentityDocumentsApi = (accountId) =>
  axiosApi.get(
    `dashboard/onboarding/current_identity_documents/?account_id=${accountId}`,
  );

export const getUpiListApi = (accountId) =>
  axiosApi.get(`dashboard/onboarding/upi_id/?account_id=${accountId}`);

export const createUpiApi = (payload) =>
  axiosApi.post(`dashboard/onboarding/upi_id/`, payload);

export const deleteUpiApi = (upiId, accountId) =>
  axiosApi.delete(`dashboard/onboarding/upi_id/${upiId}/?account_id=${accountId}`);

export const getAllDocumentsApi = (accId, kycCycleId = null) => {
  let url = `dashboard/onboarding/download_documents/?account_id=${accId}`;
  if (kycCycleId) {
    url += `&kyc_cycle_id=${kycCycleId}`;
  }
  return axiosApi.get(url, { timeout: 0 });
};

export const deleteAffliatedEntity = (id) =>
  axiosApi.delete(`dashboard/onboarding/affiliated-entities/${id}/`);

export const getUserLedgerApi = (payload) =>
  axiosApi.get(`dashboard/accounting/ledger/download/v2/`, {
    params: payload,
    timeout: 0,
  });

export const createAffiliatedEntity = (accId, payload) =>
  axiosApi.post(
    `dashboard/onboarding/affiliated-entities/?account_id=${accId}`,
    payload,
  );

export const getKybUserFiuData = (accId, kycCycleId = null) => {
  let url = `dashboard/onboarding/fiu-registration/?account_id=${accId}`;
  if (kycCycleId) {
    url += `&kyc_cycle_id=${kycCycleId}`;
  }
  return axiosApi.get(url);
};

export const updateFiuRegistrationApi = (id, payload) =>
  axiosApi.patch(`dashboard/onboarding/fiu-registration/?account_id=${id}`, payload);

export const getOnboardingSanctionsCheckApi = (accountId, kycCycleId = null) => {
  let url = `dashboard/onboarding/sanctions-check/?account_id=${accountId}`;
  if (kycCycleId) {
    url += `&kyc_cycle_id=${kycCycleId}`;
  }
  return axiosApi.get(url);
};

export const postOnboardingSanctionsCheckApi = (accountId, payload) =>
  axiosApi.post(`dashboard/onboarding/sanctions-check/?account_id=${accountId}`, payload);

export const updateBankAccountDetailsApi = (id, payload) =>
  axiosApi.patch(`kyc/onboarding/bank/${id}/`, payload);

export const verifymalewareFileApi = (fileKey) =>
  axiosApi.post(`master/scan-status`, fileKey);

export const refreshTokenApi =(refresh_token)=>
  refreshTokenRequest(refresh_token);

export const deleteKybDocApi = (payload) =>
  axiosApi.delete(`dashboard/onboarding/documents/`, { data: payload });

export const getFiuMonthlyReportApi = (year, month) =>
  axiosApi.get(
    `dashboard/accounting/fiu_monthly_report/?year=${year}&month=${month}`,
  );

export const getKycCycleHistoryApi = (accountId) =>
  axiosApi.get(`dashboard/kyc/rekyc/accounts/${accountId}/cycles/`);

export const getKycCycleStatusApi = (accountId) =>
  axiosApi.get(`dashboard/kyc/rekyc/accounts/${accountId}/status/`);

export const triggerKycCycleApi = (accountId) =>
  axiosApi.post(`dashboard/kyc/rekyc/accounts/${accountId}/trigger/`);

// Account Controls APIs
export const getAccountControlAssetInrPriceApi = (asset = "") =>
  axiosApi.get(`dashboard/account-controls/asset_inr_price/?asset=${asset}`);

export const getAccountBalancesStatusApi = (accountId = "") =>
  axiosApi.get(
    `dashboard/account-controls/balances-status/?account_id=${accountId}`,
  );

export const requestLockUnlockAccountBalanceApi = (payload) =>
  axiosApi.post("dashboard/account-controls/requests/", payload);

export const lockAccountBalanceApi = (payload) =>
  axiosApi.post("dashboard/account-controls/lock/", payload);

export const unlockAccountBalanceApi = (payload) =>
  axiosApi.post("dashboard/account-controls/unlock/", payload);

export const updateAccountControlStatusApi = (payload) =>
  axiosApi.post("dashboard/account-controls/status/", payload);

export const getAccountControlLogsApi = ({
  email = "",
  assetSymbol = "",
  actionType = "",
  startDate = "",
  endDate = "",
  page = 0,
  pageSize = 10,
} = {}) => {
  const params = new URLSearchParams();
  if (email) params.append("email", email);
  if (assetSymbol) params.append("asset_symbol", assetSymbol);
  if (actionType) params.append("action_type", actionType);
  if (startDate) params.append("start_date", startDate);
  if (endDate) params.append("end_date", endDate);
  params.append("page", page);
  params.append("page_size", pageSize);
  return axiosApi.get(`dashboard/account-controls/logs/?${params.toString()}`);
};

export const getAccountControlRequestsApi = ({
  email = "",
  accountId = "",
  assetSymbol = "",
  actionType = "",
  requestedBy = "",
  status = "",
  page = 0,
  pageSize = 10,
} = {}) => {
  const params = new URLSearchParams();
  if (email) params.append("email", email);
  if (accountId) params.append("account_id", accountId);
  if (assetSymbol) params.append("asset_symbol", assetSymbol);
  if (actionType) params.append("action_type", actionType);
  if (requestedBy) params.append("requested_by", requestedBy);
  if (status) params.append("status", status);
  params.append("page", page);
  params.append("page_size", pageSize);
  return axiosApi.get(
    `dashboard/account-controls/requests/?${params.toString()}`,
  );
};

export const reviewAccountControlRequestApi = (id, payload) =>
  axiosApi.post(`dashboard/account-controls/requests/${id}/review/`, payload);

export const createWalletRequestApi = (payload) =>
  axiosApi.post(`dashboard/onboarding/crypto-addresses/`, payload);

export const deleteWalletRequestApi = (payload) =>
  axiosApi.delete(`dashboard/onboarding/crypto-addresses/`, { data: payload });

export const getKycCycleHistoryListApi = (
  accountId = "",
  search = "",
  userType = "",
  cycleNumber = "",
  page = 0,
  pageSize = 10,
  clientType = "",
  mainAccountEmail = "",
) => {
  const params = new URLSearchParams({
    account_id: accountId ?? "",
    search: search ?? "",
    account__user_type: userType ?? "",
    cycle_number: cycleNumber ?? "",
    page: String(page),
    page_size: String(pageSize),
  });
  if (clientType) params.set("client_type", clientType);
  if (mainAccountEmail) params.set("main_account_email", mainAccountEmail);
  return axiosApi.get(`dashboard/onboarding/rekyc_list/?${params.toString()}`);
};

export const passTravelRuleApi = (id, payload) =>
  axiosApi.patch(`dashboard/otc/transaction/resolve/${id}/`, payload);

export const refreshKybDocApi = (payload) =>
  axiosApi.post(`dashboard/onboarding/company_info_refresh/`, payload);

export const refreshDirectorInfoMetadataApi = (payload) =>
  axiosApi.post(`dashboard/onboarding/company_info_refresh/`, payload);

export const getKycReviewList = (accountId = "", status = "needs_review", reviewType = "aml_internal", subjectType = "", amlHits = false, fiuHits = false) =>
  axiosApi.get(`dashboard/manual-review/cases/?account_id=${accountId}&&status=${status}&review_type=${reviewType}&subject_type=${subjectType}&has_aml_hits=${amlHits}&has_fiu_hits=${fiuHits}`);

export const acceptRejectKycReviewApi = (id, payload) =>
  axiosApi.post(`dashboard/manual-review/cases/resolve/`, payload);

export const getKycReviewAccStatusApi = (accountId = "") =>
  axiosApi.get(`dashboard/manual-review/resolve-status/?account_id=${accountId}`);

export const updateAccStatusKycReviewAccStatusApi = (id, payload) =>
  axiosApi.post(`dashboard/manual-review/resolve-status/`, payload);

export const getAuditLogsApi = (reviewCaseId = "", accountId = "", affiliatedEntityId = "", actionType = "", actorId = "", startDate = "", endDate = "", page = 0, pageSize = 10) =>
  axiosApi.get(`dashboard/manual-review/audit-logs/?review_case_id=${reviewCaseId}&account_id=${accountId}&affiliated_entity_id=${affiliatedEntityId}&action=${actionType}&actor_id=${actorId}&start_date=${startDate}&end_date=${endDate}&page=${page}&page_size=${pageSize}`);

export const rfiDistrictListApi = (params = "", pageSize = 10) => 
  axiosApi.get(`dashboard/restricted-pincodes/geo/list/?search=${params}&page_size=${pageSize}`);

export const rfiCreateDistrictApi = (payload) =>
  axiosApi.post(`dashboard/restricted-pincodes/geo/districts/`, payload);

export const deleteRfiDistrictApi = (payload) =>
  axiosApi.delete(`dashboard/restricted-pincodes/geo/districts/`, { data: payload });

export const rfiCreatePincodeApi = (payload) =>
  axiosApi.post(`dashboard/restricted-pincodes/geo/pincodes/`, payload);

export const deleteRfiPincodeApi = (payload) =>
  axiosApi.delete(`dashboard/restricted-pincodes/geo/pincodes/`, { data: payload });

export const getProfileFactorApi = (accountId) =>
  axiosApi.get(`dashboard/limits-edd/profile_factors/?account_id=${accountId}`);

export const tradingWalletUpdateListApi = (
  accountId,
  updateSource,
  page = 0,
  pageSize = 5,
  clientType = "",
) => {
  const params = new URLSearchParams({
    account_id: accountId,
    page: String(page),
    page_size: String(pageSize),
  });

  if (updateSource) {
    params.set("update_source", updateSource);
  }
  if (clientType) {
    params.set("client_type", clientType);
  }

  return axiosApi.get(
    `dashboard/otc/trading_wallet_updates/?${params.toString()}`,
  );
};

export const updateKycMainAccStatusApi = (payload) =>
  axiosApi.post(`dashboard/manual-review/resolve-status/`, payload);

export const getAddressVerificationStatusApi = (params = {}, page = 0, pageSize = 10) => {
  const isLegacyAccountId = typeof params === "string" || typeof params === "number";
  const accountId = isLegacyAccountId ? params : params.accountId || "";
  const status = isLegacyAccountId ? "" : params.status || "";
  const pageValue = isLegacyAccountId ? page : params.page ?? 0;
  const pageSizeValue = isLegacyAccountId ? pageSize : params.pageSize ?? 10;

  const query = new URLSearchParams({
    page: String(pageValue),
    page_size: String(pageSizeValue),
  });
  if (accountId) query.set("account_id", accountId);
  if (status) query.set("status", status);

  return axiosApi.get(
    `dashboard/onboarding/address_verification/status/?${query.toString()}`,
  );
};

export const updateAddressVerificationStatusApi = (payload) =>
  axiosApi.patch(`dashboard/onboarding/address_verification/update/`, payload);
